/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import axios from 'axios'
import moment from 'moment'

export default {
  data () {
    return {
      reviewList: [],
      dummyReviewData: [
        {
          'review_title': 'Best Service !',
          'review_content': 'Very good and friendy service Will for sure come back here again.Thank you very much.',
          'review_rating': 4,
          'permalink': '',
          'created_date': '2019-04-17 07:45:34',
          'author': 'Tom B',
          'formatted_created_date': 'feb 21, 2020'
        },
        {
          'review_title': 'Great customer service',
          'review_content': 'Highly Efficient great customer service Friendly and helpful staff.',
          'review_rating': 4,
          'permalink': '',
          'created_date': '2019-04-16 07:45:34',
          'author': 'Martha K',
          'formatted_created_date': 'Jan 09, 2020'
        },
        {
          'review_title': 'Efficent and friendly',
          'review_content': 'Despite being slightly late on delivery I found the overall experience efficient and friendly.',
          'review_rating': 3,
          'permalink': '',
          'created_date': '2019-04-13 07:45:34',
          'author': 'Tony S',
          'formatted_created_date': 'Jun 09, 2020'
        }
      ],
      tinyStars: true,
      showReviewBox: false,
      fetching: false
    }
  },
  methods: {
    getReviewFeed () {
      return new Promise((resolve) => {
        axios.get(`/widgets/${this.slug}/review-feed`)
          .then(({data}) => {
            if (data.length > 5) {
              this.reviewList = data
              this.fetching = false
            } else {
              this.reviewList = this.dummyReviewData
              resolve({
              showReviewBox: true
              })
              this.fetching = false
            }
          })
      })
    },
    externalUrl (permalink) {
       return `${process.env.HP_APP_URL}/${this.slug}/reviews/${permalink}`
    }
  },
  filters: {
    reviewDate (date) {
      return moment(date).format('ll')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reviews-widget.js